<template>
  <div>
    <b-modal
      id="notification-popup"
      title="Ready to publish?"
      hide-footer
    >
      <div class="d-flex flex-column align-items-center">
        <h2> {{ title }}</h2>
        <p>{{ description }}</p>
      </div>
      <hr>
      <div class="d-flex justify-content-between">
        <b-button
          variant="outline-primary"
          :disabled="loadingTestBtn"
          @click="test"
        >
          <b-spinner
            v-if="loadingTestBtn"
            small
          />
          <span v-else>Test Mode</span>
        </b-button>
        <b-button
          variant="primary"
          :disabled="loadingPublishBtn"
          @click="publish"
        >
          <b-spinner
            v-if="loadingPublishBtn"
            small
          />
          <span v-else>Publish</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    publishHandler: {
      type: Function,
      default: undefined,
    },
    testNotificationHandler: {
      type: Function,
      default: undefined,
    },
  },
  setup(props) {
    const loadingPublishBtn = ref(false)
    const loadingTestBtn = ref(false)
    const publish = async () => {
      loadingPublishBtn.value = true
      try {
        await props.publishHandler()
      } finally {
        loadingPublishBtn.value = false
      }
    }
    const test = async () => {
      loadingTestBtn.value = true
      try {
        await props.testNotificationHandler()
      } finally {
        loadingTestBtn.value = false
      }
    }

    return {
      publish,
      loadingPublishBtn,
      test,
      loadingTestBtn,
    }
  },
}
</script>

<style>

</style>
